





























































import { Component, Vue } from "vue-property-decorator"
import AuthErrorAlert from "@/components/Auth/AuthErrorAlert.vue"
import { mapState } from "vuex"

@Component({
  components: {
    AuthErrorAlert,
  },
  computed: {
    ...mapState("Auth", {
      loginDetails: "loginDetails",
    }),
  },
})
export default class LoginAccountDetails extends Vue {
  isLoading = false

  errors = []

  handleLogin() {
    this.isLoading = true
    this.$store.dispatch("Auth/login").then((response) => {
      if (response.status) {
        if (response.requireTotp) {
          this.$emit("submitted")
        } else {
          this.$router.push({ name: "dashboard" })
        }
      } else {
        this.isLoading = false
        this.errors = response.message
      }
    })
  }
}
